import React from "react";

import Box from "@mui/material/Box";
import ControlContainer from "../components/controlContainer/ControlContainer";
import ReturnToHomeButton from "../components/ReturnToHomeButton";

const Settings = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "100vh",
        margin: "auto",
        maxWidth: "970px",
        padding: "0 15px",
      }}
    >
      <Box>
        <h1>Settings</h1>
      </Box>

      <Box
        sx={{
          padding: "20px 0",
          display: "flex",
          flexFlow: "row wrap",
          justifyContent: "flex-start",
          gap: "20px",
        }}
      >
        <ControlContainer title="WORKSHEET PREFERENCES">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mauris
          mauris,
          <p>
            pellentesque consectetur volutpat vitae, vestibulum eget metus.
            Proin eu.
          </p>
        </ControlContainer>

        <ControlContainer title="AUTOSAVE PREFERENCES">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mauris
          mauris,
          <p>
            pellentesque consectetur volutpat vitae, vestibulum eget metus.
            Proin eu.
          </p>
        </ControlContainer>

        <ControlContainer title="DELETED FILES PREFERENCES">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mauris
          mauris,
          <p>
            pellentesque consectetur volutpat vitae, vestibulum eget metus.
            Proin eu.
          </p>
        </ControlContainer>

        <ControlContainer title="SUBMIT A TICKET">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mauris
          mauris,
          <p>
            pellentesque consectetur volutpat vitae, vestibulum eget metus.
            Proin eu.
          </p>
        </ControlContainer>
      </Box>

      <ReturnToHomeButton />
    </Box>
  );
};

export default Settings;
